<template>
  <div
    class="wrap"
    :style="config.backImgObj"
  >
    <img v-if="config && config?.activeType === 2" class="logo-img" src="@/assets/img/activity/100.png" alt="" />
    <div v-else class="logo-img" />
    <ul class="item-list">
      <li
        v-for="item in list"
        :key="item.id"
        class="item"
        :class="{ space: item.name && item.name.length > 2 }"
        @click="handleUnitClick(item.id)"
      >
        <img
          v-if="config?.activeType === 2"
          class="item-icon"
          src="@/assets/img/activity/item-icon.png"
          alt=""
        />
        <p class="van-multi-ellipsis--l2">{{ item.name }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { getUnitList } from '@/api/index'
import { getQueryString } from '@/utils/tools'
import { useCommonActiveStyleEffect } from '@/effects/styleConfigEffect'

// 获取单位列表
const useUnitListEffect = () => {
  const list = ref([])
  const store = useStore()
  const getData = async () => {
    const res = await getUnitList({
      activeId: store.getters.getActiveId
    })
    if (res.ok) {
      list.value = res.data
    }
  }

  getData()

  return {
    list
  }
}
// 跳转逻辑
const useClickJumpEffect = () => {
  // 点击跳转
  const router = useRouter()
  const questionActiveKey = getQueryString('questionActiveKey')
  const type = getQueryString('type')
  const store = useStore()
  const handleUnitClick = id => {
    // 绑定的是问卷 跳到问卷去
    if (type === '1') {
      location.href = `https://app-survey.iqilu.com/api/index?questionActiveKey=${questionActiveKey}&orgid=${store.getters.getOrgId}&unitId=${id}&activeId=${store.getters.getActiveId}`
      // location.href = `http://10.0.117.248:7001/?questionActiveKey=${questionActiveKey}&orgid=${store.getters.getOrgId}&unitId=${id}`
    } else {
      store.commit('setUnitId', {
        unitId: id
      })
      router.push(`/?questionActiveKey=${questionActiveKey}&unitId=${id}`)
    }
  }

  return {
    handleUnitClick
  }
}

export default {
  setup() {
    // 获取
    const { list } = useUnitListEffect()

    // 跳转
    const { handleUnitClick } = useClickJumpEffect()

    // 样式设置
    const { config } = useCommonActiveStyleEffect()

    return {
      list,
      handleUnitClick,
      config
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  position: relative;
  overflow: hidden;
  width: 100%;
  min-height: 1482px;
  background: no-repeat top/100% url('../../assets/img/activity/bg.png');
  background-color: #f62b06;
}
.logo-img {
  display: block;
  margin: 0 auto;
  padding-top: 200px;
  width: 470px;
  height: 362px;
  animation-delay: 0.5s;
}
.item-list {
  width: 100%;
  margin-top: 30px;
  padding-bottom: 120px;
  .item {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    margin-bottom: 23px;
    width: 650px;
    height: 110px;
    background: no-repeat center/100%
      url('../../assets/img/activity/list-item.png');
    color: #d21c24;
    font-size: 40px;
    font-weight: bold;
    letter-spacing: 20px;

    .item-icon {
      width: 73px;
      height: 49px;
      margin-right: 27px;
    }
  }
  .space {
    letter-spacing: 0;
  }
}
</style>
